import request from "./request.js";

/**
 * 接口请求方法
 */
const method = {
  // 获取首页数据
  index() {
    return request.get("/api/index");
    // return request.get("/index");
  },
  // 获取基础信息
  base_info() {
    return request.get("/api/index/base_info");
    // return request.get("/index");
  },
  // 关于我们
  about() {
    return request.get(`/api/index/about`);
  },
  // 联系我们
  contact() {
    return request.get(`/api/index/contact`);
  },
  // 师资力量
  team() {
    return request.get("/api/index/team");
  },
  // 师资力量详情
  teamxq(id) {
    return request.get(`/api/index/teamxq?id=${id}`);
  },
  // 培训知识
  zhishi() {
    return request.get(`/api/index/zhishi`);
  },
  // 培训知识详情
  zhishixq(id) {
    return request.get(`/api/index/zhishixq?id=${id}`);
  },
  // 学员口碑
  xueyuan() {
    return request.get("/api/index/xueyuan");
  },
  // 学员口碑详情
  xueyuanxq(id) {
    return request.get(`/api/index/xueyuanxq?id=${id}`);
  },
  // 新闻资讯
  news(cate) {
    return request.get(`/api/index/news?cate=${cate}`);
  },
  // 新闻资讯详情
  newsxq(id) {
    return request.get(`/api/index/newsxq?id=${id}`);
  },
  // 在线报名
  message(name, tel, lynr) {
    return request.post("/api/index/message", { name, tel, lynr });
  },
  // 全部课程
  course(page, page_size, cate_id, direct_id, name) {
    return request.get(
      `/api/course?page=${page}&page_size=${page_size}&cate_id=${cate_id}&direct_id=${direct_id}&name=${name}`
    );
  },
  // 课程详情-未登录
  detail(id) {
    return request.get(`/api/course/detail?id=${id}`);
  },
  // 课程详情-登录
  detail_login(id) {
    return request.get(`/api/course/detail_login?id=${id}`);
  },
  // 账号登录
  login(account, password) {
    return request.post(`/api/user/login`, {
      account,
      password,
    });
  },
  // 退出登录
  logout() {
    return request.post(`/api/user/logout`);
  },
  // 付款
  submit(id, paytype, section_id) {
    return request.post(`/api/order/submit`, {
      id,
      paytype,
      section_id,
    });
  },
  // 查询付款状态
  check_pay(paytype, out_trade_no) {
    return request.post(`/api/order/check_pay`, {
      paytype,
      out_trade_no,
    });
  },
  // 查询购买状态
  // buy_status(course_id) {
  //   return request.post(`/api/course/buy_status` ,{
  //     course_id,
  //   });
  // },
  // 已购课程
  course_list(page, page_size) {
    return request.post(`/api/user/course`, {
      page,
      page_size,
    });
  },
  // 会员注册
  register(
    username,
    password,
    mobile,
    code,
    nickname,
    email,
    zjtype,
    zjnum,
    gender
  ) {
    return request.post(`/api/user/register`, {
      username: username,
      password: password,
      mobile: mobile,
      code: code,
      nickname: nickname,
      email: email,
      zjtype: zjtype,
      zjnum: zjnum,
      gender: gender,
    });
  },
  // 修改密码
  changepwd(phone, code, password) {
    return request.post(`/api/user/changepwd`, {
      phone,
      code,
      password,
    });
  },

  // 发送验证码
  send_code(mobile, type) {
    return request.get(`/api/asms/send?mobile=${mobile}&type=${type}`);
  },
  // 忘记密码
  resetpwd(mobile, password, newpassword, code) {
    return request.post(`/api/user/resetpwd`, {
      mobile,
      password,
      newpassword,
      code,
    });
  },
};

export default method;
